import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { SessionStorageService } from "../util/session-storage.service";
import { PlatformService } from "../util/platform.service";
import { DeviceService } from "../util/device.service";
import { StorageService } from "../util/storage.service";

@Injectable({
    providedIn: "root"
})
export class PageNavigationService {
    private history: any[] = [];
    isMobile: boolean;

    constructor(
        private sessionStorage: SessionStorageService,
        private storageService: StorageService,
        private location: Location,
        private router: Router,
        private platformService: PlatformService,
        private deviceService: DeviceService 
    ) {
        if (this.platformService.isServer()) {
            return;
        }

        this.isMobile = this.deviceService.isMobile();
        
        let pageAccessedByReload = false;
        
        const entries = performance.getEntriesByType("navigation");
        entries.forEach((entry: any) => {
            if (entry.type === "reload") {
                pageAccessedByReload = true;
            }
        });

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const pageHistory = this.sessionStorage.get("page_history");

                if (window.history.length === 1) { 
                    this.history = [event.urlAfterRedirects];
                } else if (window.history.length > 1 && !this.history.length) {
                    if (pageAccessedByReload) {
                        this.history = pageHistory?.length ? pageHistory : [event.urlAfterRedirects];
                    } else {
                        this.history = [event.urlAfterRedirects];
                    }                  
                } else {
                    if (event.urlAfterRedirects === '/' || event.urlAfterRedirects === '/account') {
                        this.history = [event.urlAfterRedirects];
                    } else {
                        this.history.push(event.urlAfterRedirects);
                    }
                }

                this.sessionStorage.set('page_history', this.history);
            }
        });
    }

    back(): void {
        const history = this.sessionStorage.get('page_history');
        if (!history) {
            this.router.navigateByUrl('/');
            return;
        }
        history.pop();
        if (history.length) {
            this.location.back();
        } else {
            this.router.navigateByUrl('/');
        }
    }

    navigateToManageOrders(urlQueryParams :any = {}): void {
        if (this.isMobile) {
            this.storageService.set("scroll", "true");
            this.router.navigateByUrl('/account');
        } else {
            this.router.navigateByUrl('/profile/manage_orders', urlQueryParams);
        }
    }

    isLastPageMenuOrCategory() {
        const history = this.sessionStorage.get('page_history');

        if (history?.length) {
            history.pop();
            const lastPage = history.slice(-1)[0];
            return lastPage && (lastPage.includes("menu") || lastPage.includes("category"));
        } else {
            return false;
        }
    }
}

